import "core-js/modules/es6.function.name";
/*
 * @Descripttion: 
 * @version: 
 * @Author: 王凯
 * @LastEditors: 王凯
 */
import Vue from 'vue';
import Dialog from '@/components/Dialog';
Vue.prototype.$dialog = function (obj) {
  var id = 'custom-dialog';
  var div = document.createElement("div");
  div.id = id;
  document.body.appendChild(div);
  var DialogComponent = Vue.extend(Dialog);
  var DialogInstant = new DialogComponent({
    propsData: {
      name: obj.name,
      title: obj.title,
      width: obj.width,
      contentPropsData: obj.propsData || {}
    }
  });
  DialogInstant.$mount("#".concat(id));
  DialogInstant.show({
    methods: obj.methods
  });
};